import React from 'react';

/*
 * PROD-7828 — stat cards row (plan A4 shared/summary_cards.jsx). Props-only.
 * cards: [{ label, value, chip, tone: 'brand'|'pos'|'neg'|undefined }]
 */
const SummaryCards = ({ cards }) => (
  <div className="tp-stats">
    {cards.map((c) => (
      <div key={c.label} className={`tp-stat ${c.tone === 'brand' ? 'tp-stat-brand' : ''}`}>
        <div className="tp-stat-label">{c.label}</div>
        <div
          className="tp-stat-value"
          style={
            c.tone === 'pos'
              ? { color: 'var(--state-success)' }
              : c.tone === 'neg'
                ? { color: 'var(--state-error)' }
                : undefined
          }
        >
          {c.value}
        </div>
        {c.chip ? <span className="tp-stat-chip">{c.chip}</span> : null}
      </div>
    ))}
  </div>
);

export default SummaryCards;
